import {ViewPopup} from './ViewPopup'
import {createDivIn, setElementOnClick} from '../ui_utils/DomUtils'

export class ViewPopupAssetsLoading extends ViewPopup {
    private readonly containerDiv: HTMLDivElement
    private readonly innerDiv: HTMLDivElement
    private readonly callbacks: (() => void)[] = []

    constructor(completeAction: () => void, xAction: () => void) {
        super({key: 'strings:popups.assetsLoading'}, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, xAction, true)
        this.callbacks.push(completeAction)
        this.containerDiv = createDivIn(this.body, 'popup-loader-container')
        this.innerDiv = createDivIn(this.containerDiv, 'popup-loader-inner')
        this.removeCheckButton()
        this.removeUrlHashOnXAction()
        this.removeUrlHashOnCancel()
    }

    updateLoadPercentage(percentage: number) {
        const intPercent = Math.round(percentage)
        this.innerDiv.innerText = intPercent + '%'
        this.innerDiv.style.width = intPercent + '%'
    }

    finishedLoading() {
        if(this.isRemoved()) return
        this.callbacks.forEach((action) => action())
        this.removePopup()
    }

    addCallback(action: () => void) {
        this.callbacks.push(action)
    }

    private removeUrlHashOnXAction() {
        setElementOnClick(this.xButton, () => {
            history.replaceState('', '', location.pathname)
            this.removePopup()
        })
    }

    private removeUrlHashOnCancel() {
        window.addEventListener('click', (event: MouseEvent) => {
            if(event.target != this.container) return
            if(this.preventClicksOutsideOfPopupFromClosingPopup) return
            history.replaceState('', '', location.pathname)
            this.removePopup()
        })
    }
}
